import McIcoSuccess from "@/components/McComponents/icons/McIcoSuccess";
import McIcoWarning from "@/components/McComponents/icons/McIcoWarning";
export default {
  components: {
    McIcoSuccess: McIcoSuccess,
    McIcoWarning: McIcoWarning
  },
  methods: {
    close: function close(id) {
      this.$notify.close(id);
    }
  }
};